import PointSystemTransferModal from './PointSystemTransferModal';

export default PointSystemTransferModal;
